import { Card, Pagination } from "antd";
import React from "react";
import Icon from "../../../assets/Icon";
import Utils from "../../../utils/Utils";
import { Link, useNavigate } from "react-router-dom";
import Lottie from "react-lottie";
import noData from "../../../assets/lotties/guidePageNoData.json";
import { ArrowUpRightIcon } from "lucide-react";

const noDataJSON = {
  loop: false,
  autoplay: true,
  animationData: noData,
  // rendererSettings: {
  //   preserveAspectRatio: "xMidYMid slice",
  // },
};

function YourGuidePageData({
  guideDataFlag,
  pageNumber,
  pageSize,
  pageCount,
  onPageChange,
  notFoundFlag,
}) {
  const navigate = useNavigate();

  const handlePageChange = (page) => {
    onPageChange(page);
  };

  const handleViewGuideClick = (identifier, status) => {
    if (identifier !== "" && status === "Active") {
      navigate(`/prepareGuide/${identifier}`);
      // navigate(`/viewGuide/${identifier}`);
    }
  };

  return (
    <>
      {!notFoundFlag ? (
        <>
          <div className="mt-4 flex flex-col items-center">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[1rem] gap-x-[1.1rem] w-full">
              {guideDataFlag?.length > 0 &&
                guideDataFlag.map((item, index) => (
                  <Card
                    key={index}
                    className="w-full orange-card hover-effect driverjs-alljobs-individual-guide-card"
                  >
                    <div className="min-h-[160px] flex flex-col gap-2 justify-between">
                      <div className="flex flex-col gap-1">
                        <div className="flex flex-wrap gap-x-2 gap-y-1 justify-between break-words">
                          <div className="flex-1">
                            <p className="text-[#101828] text-[1.15rem] font-bold leading-[1.55rem]">
                              {item?.jobTitle}
                            </p>
                          </div>
                          <div className="w-[72px]">
                            {item?.guideStatus === "Active" ? (
                              <div className="active-indicator w-full ml-auto driver-js-guide-curr-status">
                                <span className="green-dot"></span>
                                <span className="text font-medium text-[.75rem]">
                                  {item?.guideStatus}
                                </span>
                              </div>
                            ) : (
                              <div className="inactive-indicator w-full ml-auto driver-js-guide-curr-status">
                                <span className="red-dot"></span>
                                <span className="text font-medium text-[.75rem]">
                                  {item?.guideStatus}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        <p className="text-[#101828] font-medium text-[1.02rem]">
                          {item?.companyName}
                        </p>
                        <div className="mt-1">
                          <div className="text-[#475467] font-medium text-[0.9rem]">
                            {item?.yearsOfExperience}+ years of experience
                          </div>
                          <div className="text-[#475467] font-medium text-[0.9rem] mt-[0.12rem]">
                            Created on{" "}
                            <strong>
                              {Utils.converToDateMonthYear(item?.creationTime)}
                            </strong>
                          </div>
                          <div className="text-[#475467] font-medium text-[0.9rem] mt-[0.12rem]">
                            {item?.jobLocation || "Location not specified"}
                          </div>
                        </div>
                      </div>
                      <div className="mt-auto flex justify-end ">
                        {item?.guideStatus === "Active" ? (
                          <span
                            className="flex items-center gap-1 hover-effect text-amber-600 font-semibold hover:text-amber-500 transition-all duration-200 text-[0.9rem] cursor-pointer driverjs-all-guide-card-action-link"
                            onClick={() =>
                              handleViewGuideClick(
                                item.jobGuideIdentifier,
                                item.guideStatus
                              )
                            }
                          >
                            View guide
                            <ArrowUpRightIcon
                              className="hover:text-amber-500"
                              size={20}
                              strokeWidth={2.5}
                              color="currentColor"
                            />
                          </span>
                        ) : (
                          <Link
                            to={`/savedraft?jobGuideIdentifier=${item.jobGuideIdentifier}`}
                          >
                            <span
                              className="flex items-center gap-2 text-amber-600 font-semibold hover:text-amber-500 text-[0.9rem] cursor-pointer driverjs-all-guide-card-action-link"
                              // onClick={() =>
                              //   handleViewGuideClick(
                              //     item.jobGuideIdentifier,
                              //     item.guideStatus
                              //   )
                              // }
                            >
                              Continue
                              <Icon
                                type="preparation-guide-external-link-icon"
                                width="16"
                                height="16"
                                color="#d97706"
                              />
                            </span>
                          </Link>
                        )}
                      </div>
                    </div>
                  </Card>
                ))}
            </div>

            <Pagination
              className="mt-4"
              current={pageNumber + 1}
              pageSize={pageSize}
              total={pageCount}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        </>
      ) : (
        <div className="mt-3">
          <Lottie style={{ maxWidth: "240px" }} options={noDataJSON} />
          <div className="text-[#475467] text-[1.05rem] font-semibold text-center mx-auto mt-[-1rem]">
            No job guides found.
          </div>
        </div>
      )}
    </>
  );
}

export default YourGuidePageData;
